<template>
  <div>
    <Button type="text" class="code-btn" id="captcha-button" :disabled="!isValid || isSending">{{isSending ? filter.dealLanguage(`${countdown}秒重新发送`, `Reacquire (${countdown})`) : filter.dealLanguage('发送验证码', 'Get Code')}}</Button>
    <div id="captcha-element" v-show="!isSending"></div>
  </div>
</template>

<script>
import { Achecksendmobliecode } from '@/service/app'
import filter from 'js/filter'
const SCENE_ID = '1j1kscam'
const MOBILE_REGEX = /^1[3-9]\d{9}$/
const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
export default {
  name: 'Captcha',
  props: {
    validMode: {
      type: String,
      default: '1', //1手机号 2邮箱
    },
    scene: {
      type: String,
      default: '',
    },
    mobile: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    mobileAreaCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filter,
      captcha: null,
      captchaButton: null,

      isSending: false,
      waitInterval: null,
      countdown: 60,
    }
  },
  computed: {
    isValid() {
      if (this.validMode == 1) {
        if (this.mobileAreaCode == '86') {
          console.log('验证手机号', this.mobile, MOBILE_REGEX.test(this.mobile))
          return MOBILE_REGEX.test(this.mobile)
        } else {
          return this.mobile !== '' && this.mobile !== undefined
        }
      } else {
        return EMAIL_REGEX.test(this.email)
      }
    },
  },
  mounted() {
    this.captchaButton = document.getElementById('captcha-button')
    this.initCaptcha()
  },
  beforeDestroy() {
    this.captchaButton = null

    this.isSending = false
    this.countdown = 60
    clearInterval(this.waitInterval)
    this.waitInterval = null

    // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
    let captchaElement = document.getElementById('aliyunCaptcha-element')
    if (captchaElement) captchaElement.remove()
    let captchaMask = document.getElementById('aliyunCaptcha-mask')
    if (captchaMask) captchaMask.remove()
  },
  methods: {
    getInstance(instance) {
      this.captcha = instance
    },
    success(captchaVerifyParam) {
      // 入参为验签captchaVerifyParam
      // 1.向后端发起业务请求进行验证码验签captchaVerifyParam校验
      // 2.根据校验结果来进行业务处理
      // 3.如业务需要重新进行验证码验证，调用验证码初始化方法initAliyunCaptcha重新初始化验证码
      this.isSending = true
      this.checkSendMoblieCode(captchaVerifyParam)
    },
    // 验证码验证不通过回调函数
    fail(error) {
      this.$Message.error(
        filter.dealLanguage('验证码发送失败，请重试', 'Delivery failed. Please retry.')
      )
      this.isSending = true
      this.countdownTimer(5)
      console.error(error)
    },
    initCaptcha() {
      window.initAliyunCaptcha({
        SceneId: SCENE_ID, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: '#captcha-button', // 触发验证码弹窗的元素。
        success: this.success,
        fail: this.fail,
        getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 360,
          height: 40,
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      })
    },
    async checkSendMoblieCode(data) {
      let res = await Achecksendmobliecode({
        data,
        sceneId: SCENE_ID,
        mobile: this.mobile,
        email: this.email,
        mobileAreaCode: this.mobileAreaCode,
        scene: this.scene,
        type: this.validMode,
      })
      if (res.code === 0 && res.data.captchaVerifyResult) {
        this.$Message.success(
          filter.dealLanguage('验证码已发送，请注意查收', 'Code sent. Please check.')
        )
        this.countdownTimer(60)
      } else {
        this.$Message.error(
          filter.dealLanguage(
            res.msg || '验证码发送失败，请重试',
            res.enMsg || 'Delivery failed. Please retry.'
          )
        )
        this.countdownTimer(5)
      }
    },
    countdownTimer(timer) {
      this.waitInterval = setInterval(() => {
        this.countdown--
        if (this.countdown == 0) {
          this.isSending = false
          this.countdown = timer
          clearInterval(this.waitInterval)
          this.initCaptcha()
        }
      }, 1000)
    },
  },
}
</script>
<style lang="stylus" scoped>
.code-btn
  color #C8161D
  border 0
  height auto
  line-height 20px
  padding 0
  background transparent
  transition all 0.3s
  box-shadow none !important
  &:hover, &:active
    color #ED4014
    background transparent
  &[disabled]
    color #999999
    background transparent
    border-color transparent
    &:hover
      color #999999
      background transparent
</style>